import { lazy, Suspense, ComponentProps } from 'react'
import Loader from 'components/SimpleLoader'

const SingleStreamView = lazy(() => import(
  /* webpackPrefetch: true */
  /* webpackChunkName: 'stream-view' */
  './SingleStreamView'
))

export function AsyncSingleStreamView(props: ComponentProps<any>) {
  return (
    <Suspense fallback={<Loader title="Loading SingleStreamView..." />}>
      <SingleStreamView {...props} />
    </Suspense>
  )
}

export default AsyncSingleStreamView
